<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Urządzenia wielofunkcyjne CX942, CX943, CX944, XC9445, XC9455, XC9465">
     Urządzenia wielofunkcyjne CX942, CX943, CX944, XC9445, XC9455, XC9465
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_pl" title="Informacje dotyczące bezpieczeństwa">
     Informacje dotyczące bezpieczeństwa
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Definicje pojęć">
      Definicje pojęć
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Informacje dotyczące produktu">
      Informacje dotyczące produktu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_pl" title="Informacje dotyczące drukarki">
     Informacje dotyczące drukarki
    </a>
   </p>
   <div id="divd0e170">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_pl" title="Znajdowanie informacji na temat drukarki">
      Znajdowanie informacji na temat drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_pl" title="Odnajdywanie numeru seryjnego drukarki">
      Odnajdywanie numeru seryjnego drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_pl" title="Wyposażenie drukarki">
      Wyposażenie drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_pl" title="Korzystanie z panelu sterowania">
      Korzystanie z panelu sterowania
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_pl" title="Opis stan&oacute;w kontrolki">
      Opis stan&oacute;w kontrolki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e560" title="Wyb&oacute;r papieru">
      Wyb&oacute;r papieru
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_pl" title="Przygotowanie, instalacja i konfiguracja">
     Przygotowanie, instalacja i konfiguracja
    </a>
   </p>
   <div id="divd0e5308">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_pl" title="Wyb&oacute;r miejsca na drukarkę">
      Wyb&oacute;r miejsca na drukarkę
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_pl" title="Podłączanie kabli">
      Podłączanie kabli
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e5491" title="Konfigurowanie i używanie aplikacji na ekranie gł&oacute;wnym">
      Konfigurowanie i używanie aplikacji na ekranie gł&oacute;wnym
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e6011" title="Konfiguracja i używanie funkcji dostępności">
      Konfiguracja i używanie funkcji dostępności
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e6314" title="Konfigurowanie drukarki w celu faksowania">
      Konfigurowanie drukarki w celu faksowania
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_pl" title="Konfigurowanie ustawień protokołu SMTP poczty e-mail">
      Konfigurowanie ustawień protokołu SMTP poczty e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_pl" title="Ładowanie papieru i nośnik&oacute;w specjalnych">
      Ładowanie papieru i nośnik&oacute;w specjalnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e8573" title="Instalacja i aktualizacja oprogramowania, sterownik&oacute;w oraz oprogramowania sprzętowego">
      Instalacja i aktualizacja oprogramowania, sterownik&oacute;w oraz oprogramowania sprzętowego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-envelope-tray-topic.html#d0e8855" title="Instalowanie wyposażenia opcjonalnego">
      Instalowanie wyposażenia opcjonalnego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="networking-intro-topic.html#d0e9833" title="Sieć">
      Sieć
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_pl" title="Zabezpieczanie drukarki">
     Zabezpieczanie drukarki
    </a>
   </p>
   <div id="divd0e10222">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_pl" title="Lokalizowanie gniazda zabezpieczeń">
      Lokalizowanie gniazda zabezpieczeń
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_pl" title="Czyszczenie pamięci drukarki">
      Czyszczenie pamięci drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_pl" title="Czyszczenie dysku pamięci drukarki">
      Czyszczenie dysku pamięci drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_pl" title="Przywracanie ustawień fabrycznych">
      Przywracanie ustawień fabrycznych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_pl" title="Informacje o ulotności pamięci">
      Informacje o ulotności pamięci
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_pl" title="Drukowanie">
     Drukowanie
    </a>
   </p>
   <div id="divd0e10414">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_pl" title="Drukowanie z komputera">
      Drukowanie z komputera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e10440" title="Drukowanie z urządzenia przenośnego">
      Drukowanie z urządzenia przenośnego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-booklet-topic.html#printing-booklet_pl" title="Drukowanie broszury">
      Drukowanie broszury
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_pl" title="Drukowanie z napędu flash">
      Drukowanie z napędu flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_pl" title="Obsługiwane napędy flash i typy plik&oacute;w">
      Obsługiwane napędy flash i typy plik&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_pl" title="Konfiguracja poufnych zadań">
      Konfiguracja poufnych zadań
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_pl" title="Drukowanie zadań poufnych i innych zadań wstrzymanych">
      Drukowanie zadań poufnych i innych zadań wstrzymanych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_pl" title="Drukowanie listy wzorc&oacute;w czcionek">
      Drukowanie listy wzorc&oacute;w czcionek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_pl" title="Drukowanie listy katalog&oacute;w">
      Drukowanie listy katalog&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_pl" title="Umieszczanie arkuszy separujących między kopiami">
      Umieszczanie arkuszy separujących między kopiami
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-printed-sheets-topic.html#stapling-printed-sheets_pl" title="Zszywanie wydrukowanych arkuszy">
      Zszywanie wydrukowanych arkuszy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_pl" title="Dziurkowanie wydrukowanych arkuszy">
      Dziurkowanie wydrukowanych arkuszy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="folding-printed-sheets-topic.html#folding-printed-sheets_pl" title="Składanie wydrukowanych arkuszy">
      Składanie wydrukowanych arkuszy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_pl" title="Korzystanie z funkcji układania offsetowego wydrukowanych arkuszy">
      Korzystanie z funkcji układania offsetowego wydrukowanych arkuszy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_pl" title="Anulowanie zadania drukowania">
      Anulowanie zadania drukowania
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_pl" title="Regulowanie intensywności tonera">
      Regulowanie intensywności tonera
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_pl" title="Kopiowanie">
     Kopiowanie
    </a>
   </p>
   <div id="divd0e11275">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_pl" title="Korzystanie z automatycznego podajnika dokument&oacute;w i szyby skanera">
      Korzystanie z automatycznego podajnika dokument&oacute;w i szyby skanera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_pl" title="Kopiowanie">
      Kopiowanie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_pl" title="Kopiowanie zdjęć">
      Kopiowanie zdjęć
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_pl" title="Kopiowanie na papierze firmowym">
      Kopiowanie na papierze firmowym
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_pl" title="Kopiowanie na obu stronach arkusza papieru">
      Kopiowanie na obu stronach arkusza papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_pl" title="Zmniejszanie lub powiększanie kopii">
      Zmniejszanie lub powiększanie kopii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_pl" title="Sortowanie kopii">
      Sortowanie kopii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_pl" title="Umieszczanie arkuszy separujących między kopiami">
      Umieszczanie arkuszy separujących między kopiami
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_pl" title="Kopiowanie kilku stron na jednym arkuszu">
      Kopiowanie kilku stron na jednym arkuszu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_pl" title="Kopiowanie kart">
      Kopiowanie kart
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-copies-topic.html#stapling-copies_pl" title="Zszywanie kopii">
      Zszywanie kopii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-copies-topic.html#punching-holes-copies_pl" title="Dziurkowanie kopii">
      Dziurkowanie kopii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-booklet-from-copied-documents-topic.html#creating-booklet-from-copied-documents_pl" title="Tworzenie broszury ze skopiowanych dokument&oacute;w">
      Tworzenie broszury ze skopiowanych dokument&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="folding-copies-topic.html#folding-copies_pl" title="Składanie kopii">
      Składanie kopii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-copies-topic.html#using-offset-stacking-copies_pl" title="Używanie opcji układania offsetowego w kopiach">
      Używanie opcji układania offsetowego w kopiach
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_pl" title="Tworzenie skr&oacute;tu kopiowania">
      Tworzenie skr&oacute;tu kopiowania
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_pl" title="Wysyłanie wiadomości e-mail">
     Wysyłanie wiadomości e-mail
    </a>
   </p>
   <div id="divd0e11705">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_pl" title="Korzystanie z automatycznego podajnika dokument&oacute;w i szyby skanera">
      Korzystanie z automatycznego podajnika dokument&oacute;w i szyby skanera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_pl" title="Wysyłanie wiadomości e-mail">
      Wysyłanie wiadomości e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_pl" title="Tworzenie skr&oacute;tu e-mail">
      Tworzenie skr&oacute;tu e-mail
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_pl" title="Faksowanie">
     Faksowanie
    </a>
   </p>
   <div id="divd0e11800">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_pl" title="Korzystanie z automatycznego podajnika dokument&oacute;w i szyby skanera">
      Korzystanie z automatycznego podajnika dokument&oacute;w i szyby skanera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_pl" title="Wysyłanie faksu">
      Wysyłanie faksu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_pl" title="Planowanie faksu">
      Planowanie faksu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_pl" title="Tworzenie skr&oacute;tu do miejsca docelowego dla faks&oacute;w">
      Tworzenie skr&oacute;tu do miejsca docelowego dla faks&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_pl" title="Zmiana rozdzielczości faksu">
      Zmiana rozdzielczości faksu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_pl" title="Dostosowywanie intensywności faksu">
      Dostosowywanie intensywności faksu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_pl" title="Drukowanie dziennika faks&oacute;w">
      Drukowanie dziennika faks&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_pl" title="Blokowanie niepożądanych faks&oacute;w">
      Blokowanie niepożądanych faks&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_pl" title="Wstrzymywanie faks&oacute;w">
      Wstrzymywanie faks&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_pl" title="Przekazywanie faks&oacute;w">
      Przekazywanie faks&oacute;w
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_pl" title="Skanowanie">
     Skanowanie
    </a>
   </p>
   <div id="divd0e12164">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_pl" title="Korzystanie z automatycznego podajnika dokument&oacute;w i szyby skanera">
      Korzystanie z automatycznego podajnika dokument&oacute;w i szyby skanera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_pl" title="Skanowanie do komputera">
      Skanowanie do komputera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_pl" title="Skanowanie do serwera FTP">
      Skanowanie do serwera FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_pl" title="Tworzenie skr&oacute;tu do FTP">
      Tworzenie skr&oacute;tu do FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_pl" title="Skanowanie do folderu sieciowego">
      Skanowanie do folderu sieciowego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_pl" title="Tworzenie skr&oacute;tu do folderu sieciowego">
      Tworzenie skr&oacute;tu do folderu sieciowego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_pl" title="Skanowanie na dysk flash">
      Skanowanie na dysk flash
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_pl" title="Używanie menu drukarki">
     Używanie menu drukarki
    </a>
   </p>
   <div id="divd0e12466">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_pl" title="Mapa menu">
      Mapa menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e12831" title="Urządzenie">
      Urządzenie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e15395" title="Drukowanie">
      Drukowanie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e16801" title="Papier">
      Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e17144" title="Kopiowanie">
      Kopiowanie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e17806" title="Faksowanie">
      Faksowanie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e20163" title="Wysyłanie wiadomości e-mail">
      Wysyłanie wiadomości e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e21213" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e21798" title="Napęd USB">
      Napęd USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e22656" title="Network/Ports (Sieć/Porty)">
      Network/Ports (Sieć/Porty)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e24837" title="Cloud Services">
      Cloud Services
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e24894" title="Bezpieczeństwo">
      Bezpieczeństwo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e26083" title="Raporty">
      Raporty
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_pl" title="Pomoc">
      Pomoc
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_pl" title="Rozwiązywanie problem&oacute;w">
      Rozwiązywanie problem&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_pl" title="Drukowanie strony ustawień menu">
      Drukowanie strony ustawień menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_pl" title="Konserwacja drukarki">
     Konserwacja drukarki
    </a>
   </p>
   <div id="divd0e26517">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_pl" title="Sprawdzanie stanu części i materiał&oacute;w eksploatacyjnych">
      Sprawdzanie stanu części i materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_pl" title="Konfigurowanie powiadomień dotyczących materiał&oacute;w eksploatacyjnych">
      Konfigurowanie powiadomień dotyczących materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_pl" title="Konfigurowanie alarm&oacute;w e-mail">
      Konfigurowanie alarm&oacute;w e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_pl" title="Oglądanie raport&oacute;w">
      Oglądanie raport&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_pl" title="Zamawianie części i materiał&oacute;w eksploatacyjnych">
      Zamawianie części i materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e26798" title="Wymiana części i materiał&oacute;w eksploatacyjnych">
      Wymiana części i materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e27785" title="Czyszczenie części drukarki">
      Czyszczenie części drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e28086" title="Oszczędzanie energii i papieru">
      Oszczędzanie energii i papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_pl" title="Przenoszenie drukarki w inne miejsce">
      Przenoszenie drukarki w inne miejsce
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_pl" title="Transport drukarki">
      Transport drukarki
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_pl" title="Rozwiązywanie problemu">
     Rozwiązywanie problemu
    </a>
   </p>
   <div id="divd0e28239">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_pl" title="Problemy z jakością wydruku">
      Problemy z jakością wydruku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_pl" title="Kody błęd&oacute;w drukarki">
      Kody błęd&oacute;w drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_pl" title="Problemy z drukowaniem">
      Problemy z drukowaniem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_pl" title="Drukarka nie odpowiada">
      Drukarka nie odpowiada
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_pl" title="Nie można odczytać napędu flash">
      Nie można odczytać napędu flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_pl" title="Włączanie portu USB">
      Włączanie portu USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_pl" title="Usuwanie zacięć">
      Usuwanie zacięć
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e32450" title="Problemy z połączeniem sieciowym">
      Problemy z połączeniem sieciowym
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e32678" title="Problem z&nbsp;opcjami sprzętowymi">
      Problem z&nbsp;opcjami sprzętowymi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e32804" title="Problemy z materiałami eksploatacyjnymi">
      Problemy z materiałami eksploatacyjnymi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e32909" title="Problemy z podawaniem papieru">
      Problemy z podawaniem papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e33275" title="problemy z wysyłaniem wiadomości e-mail">
      problemy z wysyłaniem wiadomości e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e33369" title="Problemy z&nbsp;faksowaniem">
      Problemy z&nbsp;faksowaniem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e34014" title="Problemy ze skanowaniem">
      Problemy ze skanowaniem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e34801" title="Problemy z jakością koloru">
      Problemy z jakością koloru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_pl" title="Kontakt z obsługą klienta">
      Kontakt z obsługą klienta
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_pl" title="Recykling i utylizacja">
     Recykling i utylizacja
    </a>
   </p>
   <div id="divd0e35051">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_pl" title="Recykling produkt&oacute;w Lexmark">
      Recykling produkt&oacute;w Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_pl" title="Recykling opakowań firmy Lexmark">
      Recykling opakowań firmy Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_pl" title="Oświadczenia">
     Oświadczenia
    </a>
   </p>
   <div id="divd0e35086">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35089" title="Informacje o produkcie">
      Informacje o produkcie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35106" title="Informacje o wydaniu">
      Informacje o wydaniu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_pl" title="Znaki towarowe">
      Znaki towarowe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_pl" title="Oświadczenia dotyczące licencji">
      Oświadczenia dotyczące licencji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_pl" title="Poziomy emisji hałasu">
      Poziomy emisji hałasu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_pl" title="Dyrektywa WEEE dotycząca zużytego sprzętu elektrycznego i elektronicznego">
      Dyrektywa WEEE dotycząca zużytego sprzętu elektrycznego i elektronicznego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35212" title="Akumulator litowo-jonowy">
      Akumulator litowo-jonowy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_pl" title="Rozporządzenie (UE) 2023/1542">
      Rozporządzenie (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35249" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_pl" title="Wyrzucanie produkt&oacute;w">
      Wyrzucanie produkt&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_pl" title="Zwrot kaset firmy Lexmark w celu ponownego użycia lub recyklingu">
      Zwrot kaset firmy Lexmark w celu ponownego użycia lub recyklingu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_pl" title="Ostrzeżenie o podatności na ładunki elektrostatyczne">
      Ostrzeżenie o podatności na ładunki elektrostatyczne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_pl" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_pl" title="Informacje o temperaturze">
      Informacje o temperaturze
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_pl" title="Zużycie energii">
      Zużycie energii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_pl" title="Uwagi dotyczące przepis&oacute;w dla terminali komunikacyjnych">
      Uwagi dotyczące przepis&oacute;w dla terminali komunikacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_pl" title="Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej">
      Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_pl" title="Oświadczenie dotyczące zakł&oacute;ceń radiowych">
      Oświadczenie dotyczące zakł&oacute;ceń radiowych
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue